<template>
  <div>
    <div class="preview-color" :style="`background: linear-gradient(to bottom, ${startColor}, ${endColor});`"></div>
    <div class="gradient-color-picker">
      <v-row>
        <v-col cols="6">
          <div style="gap: 10px" class="d-flex align-center gap-3">
            <input
              style="display: block; width: 40px; height: 40px"
              type="color"
              class="start-color"
              :value="startColor"
              @input="event => handleUpdateStartColor(event.target.value)"
            />
            <v-text-field :value="startColor" label="Start Color" @input="handleUpdateStartColor" />
          </div>
        </v-col>
        <v-col cols="6">
          <div style="gap: 10px" class="d-flex align-center gap-3">
            <input
              style="display: block; width: 40px; height: 40px"
              type="color"
              class="end-color"
              :value="endColor"
              @input="event => handleUpdateEndColor(event.target.value)"
            />
            <v-text-field :value="endColor" label="End Color" @input="handleUpdateEndColor" />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GradientColorPicker',
  data() {
    return {};
  },
  props: {
    startColor: {
      type: String,
      default: '#000000',
    },
    endColor: {
      type: String,
      default: '#ffffff',
    },
  },
  methods: {
    handleUpdateStartColor(color) {
      this.$emit('update:startColor', color);
    },
    handleUpdateEndColor(color) {
      this.$emit('update:endColor', color);
    },
  },
};
</script>
<style lang="scss" scoped>
.preview-color {
  height: 200px;
  margin-bottom: 10px;
  display: block;
}
</style>
